import { HttpErrorResponse } from '@angular/common/http';
import { Dataset } from './dataset-types';
import {
  DatasetResult,
  SwitchView,
  SwitchViewDomain,
  ThoughtspotDatasetPublicationResponse,
  DatasetDetails,
  ExportedDatasetSourceContent,
  ProducerType,
} from '@mode/shared/contract-common';
import { createAction, props } from '@ngrx/store';

export const loadDatasetViewRoute = createAction('[Dataset View Page] LOAD_DATASET', props<{ datasetToken: string }>());
export const loadDatasetEditRoute = createAction('[Dataset Edit Page] LOAD_DATASET', props<{ datasetToken: string }>());
export const loadDatasetReportEditRoute = createAction(
  '[Report Edit Page] LOAD_DATASET',
  props<{ datasetToken: string }>()
);
export const loadNotebookCellDatasetEditRoute = createAction(
  '[Report Edit Page] LOAD_NOTEBOOK_CELL_DATASET',
  props<{ datasetToken: string; switchViewToken: string }>()
);

export const loadDatasetReportEditRouteSuccess = createAction(
  '[Report Edit Page] LOAD_DATASET success',
  props<{ dataset: Dataset }>()
);

export const loadDatasetSuccess = createAction(
  '[Dataset View Page] LOAD_DATASET_SUCCESS',
  props<{ datasetResult: DatasetResult; switchView: SwitchView; token: string; details?: DatasetDetails }>()
);

export const loadImportedDataset = createAction(
  '[Report Edit Page] LOAD_IMPORTED_DATASET',
  props<{ switchViewToken: string }>()
);

export const loadDatasetFailure = createAction(
  '[Dataset View Page] LOAD_DATASET_FAILURE',
  props<{ error: HttpErrorResponse }>()
);

export const deleteDataset = createAction('[Dataset Edit Page] DELETE_DATASET', props<{ datasetToken: string }>());
export const deleteDatasetSuccess = createAction('[Dataset Edit Page] DELETE_DATASET_SUCCESS');
export const deleteDatasetFail = createAction('[Dataset Edit Page] DELETE_DATASET_FAIL');

export const removePhantomDatasetClicked = createAction(
  '[Report Edit Page] REMOVE_PHANTOM_DATASET_FROM_REPORT',
  props<{ accountId: string; reportId: string; switchViewToken: string }>()
);

export const googleSheetSyncCompleted = createAction(
  '[Dataset Edit Page] GOOGLE_SHEET_SYNC_COMPLETED',
  props<{ dataView: SwitchViewDomain.DataView }>()
);

export const runDatasetPollingCompleted = createAction(
  '[Dataset Edit Page] RUN_DATASET_POLLING_COMPLETED',
  props<{ datasetToken: string }>()
);

export const openDeleteDatasetModal = createAction(
  '[Dataset Edit Page] OPEN_DELETE_DATASET_MODAL',
  props<{ token: string }>()
);

export const openDeleteDatasetModalFromCollectionList = createAction(
  '[Collection List] OPEN_DELETE_DATASET_MODAL',
  props<{ token: string }>()
);

export const openDeleteDatasetModalFromCollectionTile = createAction(
  '[Collection Tile] OPEN_DELETE_DATASET_MODAL',
  props<{ token: string }>()
);

export const openDeleteDatasetModalFromCollectionSidePanel = createAction(
  '[Collection Side Panel] OPEN_DELETE_DATASET_MODAL',
  props<{ token: string }>()
);

export const deleteFromCollection = createAction(
  '[Collection] DELETE_DATASET_FROM_COLLECTION',
  props<{ token: string }>()
);

export const deleteFromCollectionView = createAction(
  '[Collection] DELETE_DATASET_FROM_COLLECTION_VIEW',
  props<{ token: string }>()
);

export const openPublishModal = createAction(
  '[Publish Dataset] Open Publish Dataset Modal',
  props<{ switchViewToken: string }>()
);

export const openUnpublishModal = createAction(
  '[Unpublish Dataset] Open Unpublish Dataset Modal',
  props<{ switchViewToken: string }>()
);

export const openRepublishModal = createAction(
  '[Republish Dataset] Open Republish Dataset Modal',
  props<{ switchViewToken: string }>()
);

export const publishDataset = createAction(
  '[Publish Dataset] Publish Dataset',
  props<{
    datasetToken: string;
    name: string;
    producerType: ProducerType;
    queryToken?: string;
    switchViewToken?: string;
  }>()
);

export const publishDatasetSuccess = createAction(
  '[Publish Dataset] Publish Dataset Success',
  props<{
    datasetPublicationResponse: ThoughtspotDatasetPublicationResponse;
    name: string;
    datasetToken: string;
    producerType: ProducerType;
    queryToken?: string;
    switchViewToken?: string;
  }>()
);

export const publishDatasetFailure = createAction(
  '[Publish Dataset] Publish Dataset Failure',
  props<{ error: HttpErrorResponse }>()
);

export const republishDataset = createAction(
  '[Republish Dataset] Republish Dataset',
  props<{ datasetThoughtspotPublicationToken: string }>()
);

export const republishDatasetSuccess = createAction('[Republish Dataset] Republish Dataset Success');

export const republishDatasetFailure = createAction(
  '[Republish Dataset] Republish Dataset Failure',
  props<{ error: HttpErrorResponse }>()
);

export const unpublishDataset = createAction(
  '[Unpublish Dataset] Unpublish Dataset',
  props<{
    datasetToken: string;
    producerType: ProducerType;
    switchViewToken: string;
    datasetThoughtspotPublicationToken: string;
  }>()
);

export const unpublishDatasetSuccess = createAction(
  '[Unpublish Dataset] Unpublish Dataset Success',
  props<{ switchViewToken: string }>()
);

export const unpublishDatasetFailure = createAction(
  '[Unpublish Dataset] Unpublish Dataset Failure',
  props<{ error: HttpErrorResponse }>()
);

export const fetchExportedDatasetSource = createAction(
  '[Exported Dataset] Exported Dataset Source',
  props<{ queryToken: string }>()
);

export const fetchExportedDatasetSourceSuccess = createAction(
  '[Exported Dataset] Exported Dataset Source Success',
  props<{ response: ExportedDatasetSourceContent }>()
);

export const fetchExportedDatasetSourceFailure = createAction(
  '[Exported Dataset] Exported Dataset Source Failure',
  props<{ error?: HttpErrorResponse }>()
);

export const publishDatasetAfterMoveSpace = createAction(
  'PublishDataset After MoveSpace',
  props<{ switchViewToken: string }>()
);
